import React, { createContext, useContext, useState, ReactNode } from 'react';

// Define o tipo para o usuário
interface User {
  id: string;
  name: string;
  email: string;
}

// Define o tipo para o contexto de autenticação
interface AuthContextType {
  user: User | null;
  login: (email: string, password: string) => Promise<boolean>;
  logout: () => void;
}

// Cria o contexto de autenticação
const AuthContext = createContext<AuthContextType | undefined>(undefined);

// Props para o AuthProvider
interface AuthProviderProps {
  children: ReactNode;
}

// Provider component
export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [user, setUser] = useState<User | null>(null);

  // Função de login simplificada
  const login = async (email: string, password: string): Promise<boolean> => {
    // Simulação de login bem-sucedido
    const mockUser = {
      id: '1',
      name: 'Usuário Teste',
      email
    };
    setUser(mockUser);
    return true;
  };

  // Função de logout
  const logout = () => {
    setUser(null);
  };

  // Valor do contexto
  const value = {
    user,
    login,
    logout
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

// Hook para usar o contexto de autenticação
export const useAuth = (): AuthContextType => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth deve ser usado dentro de um AuthProvider');
  }
  return context;
};

export default useAuth; 